import React, { ChangeEvent, forwardRef } from "react";
import { Grid2, IconButton, Switch, TextField, Typography } from "@mui/material";
import { AddPartnerRequest, PartnerDto, PartnersRycApiClient, UpdatePartnerRequest } from "../../Api/ApiServer";
import { ArrowBack } from "@mui/icons-material";
import { useApi } from "../../Api/useApi";

interface PartnerDetailProps {
  partner: PartnerDto;
  onSaved: () => void;
}

export interface PartnerDetailRef {
    onSavePartner: () => void;
}

const PartnerDetail = forwardRef<PartnerDetailRef, PartnerDetailProps>(({ partner, onSaved }, ref) => {
  const [partnerState, setPartnerState] = React.useState<PartnerDto>(partner);
  const { authorizedApi } = useApi(PartnersRycApiClient);

  const savePartner = React.useCallback(async () => {
    if (authorizedApi && partnerState && partnerState.name) {
        if (!partnerState.id) {
            await authorizedApi.addPartner(new AddPartnerRequest({ partner: partnerState})).then(() => {
                onSaved();
            });
        } else {
            await authorizedApi.updatePartner(new UpdatePartnerRequest({ partner: partnerState})).then(() => {
                onSaved();
            });
        }
    }
  }, [partnerState, authorizedApi, onSaved]);

  React.useImperativeHandle(ref, () => ({
    onSavePartner: savePartner
  }), [savePartner]);

  React.useEffect(() => {
    setPartnerState(partner);
  }, [partner]);

  return (
    <Grid2 container spacing={2} sx={{ maxWidth: 600, margin: "auto" }}>   
      <Grid2 size={{ xs: 12 }}>

        <Grid2 size={{ xs: 12 }} pb={2} container alignItems="center">
            <Typography fontWeight={'bold'} sx={{ mr: 1 }}>Osoba</Typography>
            <Switch
                checked={partnerState.isCompany}
                onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, isCompany: e.target.checked }))}
            />
            <Typography fontWeight={'bold'} sx={{ mr: 1 }}>Firma</Typography>
        </Grid2>
        <TextField
          fullWidth
          label="Název"
          name="name"
          value={partnerState.name}
          onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, name: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={partnerState.email}
          onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, email: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Telefoní číslo"
          name="phone"
          type="tel"
          value={partnerState.phone}
          onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, phone: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Adresa"
          name="address"
          value={partnerState.address}
          onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, address: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

        {partnerState.isCompany && <Grid2 size={{ xs: 12 }}>
            <TextField
                fullWidth
                label="IČO"
                name="ico"
                value={partnerState.ico}
                onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, ico: e.target.value }))}
                variant="outlined"
            />
        </Grid2>}

        {partnerState.isCompany && <Grid2 size={{ xs: 12 }}>
            <TextField
                fullWidth
                label="Jednatel"
                name="director"
                value={partnerState.director}
                onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, director: e.target.value }))}
                variant="outlined"
            />
        </Grid2>}

        <Grid2 size={{ xs: 12 }}>
            <TextField
                fullWidth
                label="Bankovní účet"
                name="accountId"
                value={partnerState.bankId}
                onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, bankId: e.target.value }))}
                variant="outlined"
            />
        </Grid2>

        {partnerState.isCompany && <Grid2 size={{ xs: 12 }}>
            <TextField
                fullWidth
                label="Obchodní zápis"
                name="registry"
                value={partnerState.businessRegistry}
                onChange={(e) => setPartnerState(new PartnerDto({ ...partnerState, businessRegistry: e.target.value }))}
                variant="outlined"
            />
        </Grid2>}
    </Grid2>
  );
});

export default PartnerDetail;
